export const providingKey =
  'descriptions.admin-portal.workshops.details.basic-info.providing';
